import {
    Button, Modal, ModalBody, ModalContent,
    ModalFooter, ModalHeader, ModalOverlay, Spacer, Text,
    useToast,
} from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ThemeTokens } from '@acp/core-ui';
import { PropertyAddressCard } from './property-address-card';
import { archiveTenancy } from '../../tenancy/service';

export function ArchiveTenancyModal({
    propertyId,
    tenancyId,
    isOpen,
    onClose,
}: {
    propertyId: number;
    tenancyId: number;
    isOpen: boolean;
    onClose: () => void;
}) {
    const queryClient = useQueryClient();
    const toast = useToast();

    const mutation = useMutation({
        mutationFn: () => archiveTenancy(propertyId, tenancyId),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: ['property', propertyId],
            });

            toast({
                title: 'Tenancy archived',
                description: 'Tenancy was successfully archived.',
                status: 'success',
                isClosable: true,
            });

            onClose();
        },
        onError: (error) => {
            toast({
                title: 'Failed to archive tenancy',
                description: error.message,
                status: 'error',
                isClosable: true,
            });
        },
    });

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    Archive tenancy
                </ModalHeader>
                <ModalBody>
                    <PropertyAddressCard propertyId={propertyId} mb={6} />
                    <Text>
                        Are you sure you want to archive this tenancy? This action cannot be undone.
                    </Text>
                </ModalBody>
                <ModalFooter mt={6}>
                    <Button
                        onClick={onClose}
                        borderColor={ThemeTokens.Defaults.borderColor}
                        color="muted.700"
                        bgColor="white"
                        variant="outline"
                        size="md"
                    >
                        Cancel
                    </Button>
                    <Spacer />
                    <Button
                        isLoading={mutation.isPending}
                        onClick={() => mutation.mutate()}
                        size="md"
                    >
                        Archive
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
